import React from 'react';
import classNames from 'classnames';

import CheckboxRow, {
  Props as CheckboxRowProps,
} from 'components/UI/Form/Row/CheckboxRow/CheckboxRow';
import { COLORS } from 'settings/filters';

import styles from './ColorCheckboxRow.module.scss';

type PropsType = Omit<CheckboxRowProps, 'label'> & { label: string };

export default function ColorCheckboxRow(props: PropsType): JSX.Element {
  const { label, classes, ...rest } = props;
  const color = COLORS[(label as string).toUpperCase()] ?? label;

  return (
    <CheckboxRow
      label={label}
      classes={{
        ...classes,
        icon: classNames(classes?.icon, styles.icon),
        checkedIcon: classNames(classes?.checkedIcon, styles.iconChecked),
      }}
      style={
        {
          '--background-color': color,
        } as React.CSSProperties
      }
      {...rest}
    />
  );
}
